"use strict";
var Observable_1 = require('../../Observable');
var fromPromise_1 = require('../../observable/fromPromise');
Observable_1.Observable.fromPromise = fromPromise_1.fromPromise;
//# sourceMappingURL=fromPromise.js.map


//////////////////
// WEBPACK FOOTER
// /root/anvel/~/rxjs/add/observable/fromPromise.js
// module id = ../../../../rxjs/add/observable/fromPromise.js
// module chunks = 4